import ReactFinalForm from 'components/form/ReactFinalForm';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { useEffect, useState } from 'react';
import { tenantSettingsService } from 'services/api';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import MailOutline from '@mui/icons-material/MailOutline';

interface ShowEmailTiketingParams {
  hasBeenSent?: boolean;
  equipment_id?: number;
  equipment_cc_email?: string;
  equipment_email?: string;
  warehouse_code?: string | null;
  warehouse_phone?: string | null;
  onSubmit: (text) => void;
}
function ShowEmailTiketingDialog(params: ShowEmailTiketingParams) {
  const translationPrefix = 'pages.tickets';
  const { t } = useTranslation();
  const {
    hasBeenSent,
    equipment_id,
    equipment_cc_email,
    equipment_email,
    warehouse_code,
    warehouse_phone,
    onSubmit
  } = params;

  const [emailBody, setEmailBody] = useState<string>();
  const [emailCC, setEmailCC] = useState<string>();
  const [sendDialog, setSendDialog] = useState(false);

  useEffect(() => {
    tenantSettingsService.get(1).then((res) => {
      const defaultBody = res.ticketing_default_email_body || '';
      const warehouseLine = warehouse_phone
        ? `Telefono magazzino dello strumento: ${warehouse_phone}`
        : '';
      const bodyWithWarehouse = warehouseLine
        ? `${defaultBody}\n${warehouseLine}`.trim()
        : defaultBody;
      setEmailBody(bodyWithWarehouse);
      const emailCC = [res.cc_ticketing, equipment_cc_email]
        .filter(Boolean)
        .map((item) => item.replace(/;/g, ' '))
        .join(' ');
      setEmailCC(emailCC);
    });
  }, [equipment_id, warehouse_phone, warehouse_code]);

  const opensetSendDialog = () => {
    setSendDialog(true);
  };

  const closesetSendDialog = () => {
    setSendDialog(false);
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    closesetSendDialog();
  };

  return (
    <div>
      <Button variant="outlined" size="small" onClick={opensetSendDialog} disabled={hasBeenSent}>
        <MailOutline className="mr-2" />
        {hasBeenSent ? t(`${translationPrefix}.sent`) : t(`${translationPrefix}.send`)}
      </Button>
      <Dialog open={sendDialog} maxWidth="md" fullWidth onClose={closesetSendDialog}>
        <DialogTitle>{t(`${translationPrefix}.show-email`)}</DialogTitle>
        <DialogContent>
          {/* Replace with your actual ShowEmailTiketing props if needed */}

          <ReactFinalForm onSubmit={handleSubmit} formId="sendEmailTicketing" hideControls>
            <div className="w-full p-4">
              <IdentityField
                name="email_recipient"
                component={TextFieldAdapter}
                label={t('global.recipient')}
                placeholder={t('global.recipient-placeholder')}
                initialValue={equipment_email ? equipment_email : ''}
                type="text"
              />
            </div>
            <div className="w-full p-4">
              <IdentityField
                name="email_cc"
                component={TextFieldAdapter}
                label={t('global.cc')}
                initialValue={emailCC ? emailCC : ''}
                type="text"
              />
            </div>
            <div className="w-full p-4">
              <IdentityField
                name="email_body"
                component={TextFieldAdapter}
                label={t('global.message')}
                placeholder={t('global.message-placeholder')}
                initialValue={emailBody ? emailBody : ''}
                type="text"
                multiline
                rows={4}
              />
            </div>
          </ReactFinalForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={closesetSendDialog} color="error">
            {t('actions.cancel')}
          </Button>
          <Button type="submit" form="sendEmailTicketing">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ShowEmailTiketingDialog;
